import { Command } from 'protractor';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {select, Store} from '@ngrx/store';
import {CommandService} from '@core/services/command.service';
import {BasketProvider} from '@shared/models/basket-provider';
import {IFileStoreState} from '@shared/store/reducers/file-store.reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Guid} from 'guid-typescript';
import {ConversationComponentName} from '@features/task-manager/collaboration/store/collaboration.constants';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {FileModel} from '@shared/models/file-model';
import {MatDialog} from '@angular/material/dialog';
import {UploadFileAction} from '@shared/store/actions/file-store.actions';
import {ActivatedRoute, Router} from '@angular/router';
import {QueryProvider} from '@shared/queries/query-provider';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {Dac6ReporterApiService} from '@features/dac6-reporter/services/dac6-reporter.service';
import {TransmitFileCommand} from '@features/dac6-reporter/components/transmissions/commands/transmission.command';
import {CreateChatConversationCommand} from '@features/task-manager/collaboration/store/collaboration.command';
import {EventEmitter, Injectable} from '@angular/core';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {FilingErrorReportComponent} from '@features/dac6-reporter/components/filing-error-report/filing-error-report.component';
import {CollaborationState} from '@features/task-manager/collaboration/store/collaboration.reducer';
import {Observable, Subject} from 'rxjs';
import {getFileModel} from '@shared/store/selectors/file-store.selector';
import {ManualTransmitFileCommand} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {DialogModel} from '@shared/models/dialog.model';
import {CreateChatConversationAction} from '@features/task-manager/collaboration/store/collaboration.action';
import {DialogService} from '@shared/services/dialog-service';
import {take, takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import { Api } from '@shared/constants/common-field.constants';

@Injectable({
  providedIn: 'root'
})

export class PlatformToolDac6TransmissionDataHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  activatedRoute: ActivatedRoute;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private dac6ApiService: Dac6ReporterApiService,
    private dialog: MatDialog,
    private queryState: Store<IQueryState>,
    private collaborationStore: Store<CollaborationState>,
    protected commandService: CommandService,
    private fileStore: Store<IFileStoreState>,
    private fileStoreCommonService: FileStoreCommonService
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }
  executeCommand(command: PlatformCommand) {
    console.log(command);
    switch (command.name) {
      case 'Dac6UploadReportForTransmissionCommand':
        this.uploadTransmission();
        break;
    }
  }

  uploadTransmission() {
    const currentBasket = BasketProvider.getCurrentBasket();
    if (currentBasket && currentBasket.id === 'dac6-mx') {
      this.dialogService.showDialogMessage('Warning', 'You can not upload report in Mexico MDR basket. Please switch basket to EU Countries to upload report.');
    } else {
      const input = {
        title: '',
        bZStNumber: 'bx100036781',
        accountID: '1054252483',
        identificationNumber: '',
        fileType: '',
        allowEncryption: false,
        hasXmlValidation: true,
        metaData: {},
        additionalData: {},
        endpointName: this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"]
      };
      const dialogModel: DialogModel = DialogModel.create(
        'Upload Report',
        'UploadReportForTransmissionComponent',
        input,
        '600px',
        '700px'
      );
      dialogModel.isDisabledOkButton = true;
      dialogModel.okCaption = 'Next';
      this.dialogService
        .showOkCancelDialog(dialogModel)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res) => {
          if (res && res.action === 'OK') {
            let inputData = res.data.input;
            let fileModel$: Observable<FileModel>;
            let unsubscribe$ = new Subject<void>();
            const directoryPath = `Root/${Guid.create().toString()}/Uploads`;
            const key = Guid.create().toString();
            const fileModel = FileModel.createClientFileModel(directoryPath, inputData.importFile, key);
            fileModel$ = this.fileStore.pipe(select(getFileModel, key));
            fileModel$.pipe(takeUntil(unsubscribe$)).subscribe(state => {
              if (state && state.fileId) {
                let manualTransmitFileCommand;
                if(this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"] == Api.FilingManagerApi){
                 // command = new TransmitFileCommand(transmitKey, countryCode, metaData,Api.FilingManagerApi);
                  manualTransmitFileCommand = new ManualTransmitFileCommand(
                    inputData.reportingEntityName,
                    inputData.reportingCountryCode,
                    state.fileId,
                    'DAC6',
                    inputData.reportingFrequency,
                    inputData.identificationNumber,
                    inputData.allowEncryption,
                    inputData.hasXmlValidation,
                    inputData.metaData,
                    inputData.additionalData,
                    Api.FilingManagerApi
                  );
                }
                else {
                  manualTransmitFileCommand = new ManualTransmitFileCommand(
                    inputData.reportingEntityName,
                    inputData.reportingCountryCode,
                    state.fileId,
                    'DAC6',
                    inputData.reportingFrequency,
                    inputData.identificationNumber,
                    inputData.allowEncryption,
                    inputData.hasXmlValidation,
                    inputData.metaData,
                    inputData.additionalData
                  );
                }
                this.commandService.executeCommand(manualTransmitFileCommand)
                  .pipe().subscribe(commandState => {
                  this.showErrorReportDialog(commandState);
                  this.fuseSplashScreenService.hide();
                });
                unsubscribe$.next();
                unsubscribe$.complete();
              }
            });
            this.fuseSplashScreenService.show();
            this.fileStore.dispatch(new UploadFileAction(key, inputData.importFile, fileModel, true));
          }
        });
    }
  }

  showErrorReportDialog(exportCommandResopnse) {
    const dialogRef = this.dialog.open(FilingErrorReportComponent, {
      minWidth: '750px',
      maxWidth: '850px',
      data: {
        transmitToAuthority: true,
        formId: exportCommandResopnse.Payload.MetaData.FormId,
        hasError: exportCommandResopnse.Payload.HasError,
        countryCode: exportCommandResopnse.Payload.MetaData.CountryCode
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: string) => {
      if (result) {
        switch (result) {
          case 'transmit-to-authority':
            this.openTransmitFillingDialoge(exportCommandResopnse);
            break;
        }
      }
    });
  }

  openTransmitFillingDialoge(exportCommandResopnse) {
    let transmitKey = [], countryCode = '';
    if (exportCommandResopnse.Payload &&
      exportCommandResopnse.Payload.MetaData &&
      exportCommandResopnse.Payload.MetaData.transmitKey &&
      exportCommandResopnse.Payload.MetaData.transmitKey.length > 0) {
      transmitKey = exportCommandResopnse.Payload.MetaData.transmitKey;
    }
    if (exportCommandResopnse.Payload &&
      exportCommandResopnse.Payload.MetaData &&
      exportCommandResopnse.Payload.MetaData.CountryCode &&
      exportCommandResopnse.Payload.MetaData.CountryCode.length > 0) {
      countryCode = exportCommandResopnse.Payload.MetaData.CountryCode;
    }
    this.fuseSplashScreenService.show();
    this.dac6ApiService.getAgreementByCountryCode(exportCommandResopnse.Payload.MetaData.CountryCode,this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"]).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      if (response) {
        const dialogModel: DialogModel = DialogModel.create(
          'Transmit Form(s)',
          'ConfirmTransmissionDialogComponent', {}
        );
        dialogModel.okCaption = 'Transmit';
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
          if(item.action === 'OK') {
            let metaData = {};
            if (item &&
              item.data &&
              item.data.input &&
              item.data.input.TransmissionData &&
              item.data.input.TransmissionData.cells) {
              metaData = this.getDictionary(item.data.input.TransmissionData.cells);
            }
            let command;
            if(this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"] == Api.FilingManagerApi){
              command = new TransmitFileCommand(transmitKey, countryCode, metaData,Api.FilingManagerApi);
            }
            else command = new TransmitFileCommand(transmitKey, countryCode, metaData);
            this.fuseSplashScreenService.show();
            this.commandService.executeCommand(command).subscribe(response => {
              this.fuseSplashScreenService.hide();
              this.invalidateSubject.invalidate();
              // this.router.navigate(['dac6-reporter/transmissions']);
            });
          }
        });
      }
    });
  }

  getDictionary(dict: any) {
    const ret = {};
    for (const key in dict) {
      ret[key] = dict[key].value;
    }
    return ret;
  }

  valueChanged(event: any) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'ReportName') {
      return;
    } else if (event.fieldDefinition && event.fieldDefinition.key === 'Details') {
      this.viewDetails(event);
      return;
    } else if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.navigateToTransmissionFolder(event, 'DAC6 Reporter/[CASE_ID]/Transmissions');
    }
    if (event.action) {
      switch (event.action.id) {
        case 'ViewSentDocuments':
          this.navigateToTransmissionFolder(event);
          break;
        case 'ViewReceivedDocuments':
          this.navigateToTransmissionFolder(event);
          break;
        case 'OpenConversation':
          this.getChatForThisCase(event);
          break;
      }
    }
    console.log(event);
  }


  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.id, // CaseGUID -> CaseId
        caseId: event.item.cells['CaseId'].displayText // CaseId -> CaseDisplayId
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `Transmission-${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6-Transmission',
      [],
      true,
      event.item.id,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToTransmissionFolder(event: any, relativePath: string = '') {
    console.log('navigateToTransmissionFolder', event);
    const caseId = event.item.cells['CaseId'].displayText;
    if (relativePath !== '') {
      relativePath = relativePath.replace('[CASE_ID]', caseId);
    } else if (event.action && event.action.tags.length) {
      relativePath = event.action.tags[0];
    }
    // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath')).pipe(take(2));
    // relativeUrl$.subscribe(state => {
    //   console.log('RelativeUrl', state);
    //   if (state) {
    //     console.log('Inside Routing ', state);
    //     this.router.navigateByUrl(state);
    //   }
    // });
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
    // console.log('rellativePath', relativePath);
    // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
  }

  viewDetails(event: any) {
    if (event.item.cells) {
      const dialogModel: DialogModel = DialogModel.create(
        'Status Details',
        'TransmissionViewDetailsDialogComponent',
        {
          item: event.item.cells
        },
        '600px',
        '700px'
      );
      dialogModel.isDisabledOkButton = false;
      this.dialogService.showOkCancelDialog(dialogModel);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    //const config = Configuration.getSmartGridConfig(selectedTab.tabData.SourceType);
    //config.Parameters.FILING_TYPE = selectedTab.tabData.FILING_TYPE;
    //Configuration.setSmartGridConfig(selectedTab.tabData.SourceType, config);
  }
  destroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  selectionChanged?($event: any): void {

  }
  redirectTo(url) {
    this.router.navigateByUrl(url);
  }
}
